var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "38.5 38.5 123 123",
    viewBox: "38.5 38.5 123 123",
    height: 200,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    role: "presentation",
    "aria-hidden": "true",
    "aria-label": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "#comp-kxyo07xv svg [data-color=\"1\"] {fill: #CA9400;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E4A118",
    d: "M158.572 82.429v5.857H41.429v-5.857h117.143z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4A118",
    d: "M123.428 53.143V59H76.571v-5.857h46.857z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.714 161.5H47.286c-4.845 0-8.786-3.941-8.786-8.786V61.929c0-4.845 3.941-8.786 8.786-8.786H59V59H47.286a2.931 2.931 0 0 0-2.929 2.929v90.786a2.931 2.931 0 0 0 2.929 2.929h105.429a2.931 2.931 0 0 0 2.929-2.929V61.929A2.931 2.931 0 0 0 152.715 59H141v-5.857h11.714c4.845 0 8.786 3.941 8.786 8.786v90.786c0 4.844-3.941 8.785-8.786 8.785z",
    fill: "#E4A118",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.929 67.786H120.5V44.357a5.864 5.864 0 0 1 5.857-5.857h11.714a5.864 5.864 0 0 1 5.857 5.857v23.429zm-17.572-5.857h11.714V44.357h-11.714v17.572z",
    fill: "#E4A118",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5 67.786H56.071V44.357a5.864 5.864 0 0 1 5.857-5.857h11.714a5.864 5.864 0 0 1 5.857 5.857v23.429zm-17.571-5.857h11.714V44.357H61.929v17.572z",
    fill: "#E4A118",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4A118",
    d: "M94.143 102.929v5.857H82.429v-5.857h11.714z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4A118",
    d: "M117.571 102.929v5.857h-11.714v-5.857h11.714z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4A118",
    d: "M141 102.929v5.857h-11.714v-5.857H141z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4A118",
    d: "M70.714 117.571v5.857H59v-5.857h11.714z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4A118",
    d: "M94.143 117.571v5.857H82.429v-5.857h11.714z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4A118",
    d: "M117.571 117.571v5.857h-11.714v-5.857h11.714z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4A118",
    d: "M141 117.571v5.857h-11.714v-5.857H141z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4A118",
    d: "M70.714 132.214v5.857H59v-5.857h11.714z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4A118",
    d: "M94.143 132.214v5.857H82.429v-5.857h11.714z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4A118",
    d: "M117.571 132.214v5.857h-11.714v-5.857h11.714z",
    "data-color": 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step-2.89771f00d573c173eb4942020d06ef60.svg";
export { ForwardRef as ReactComponent };